(function () {
  var chars = 'SCHUHEIDA+X';
  var targets = new WeakMap();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function targetFor(element) {
    if (!targets.has(element)) {
      targets.set(element, element.textContent);
    }
    return targets.get(element);
  }

  function scramble(element) {
    if (!element || element.matches(':disabled, [aria-disabled="true"], .btn-disabled, .sch-btn--disabled')) {
      return;
    }

    var target = targetFor(element);
    window.clearInterval(element._schScrambleTimer);

    if (reducedMotion.matches) {
      element.textContent = target;
      return;
    }

    var frame = 0;
    var total = 12;
    element._schScrambleTimer = window.setInterval(function () {
      frame += 1;
      var reveal = Math.floor((frame / total) * target.length);
      var output = '';

      for (var index = 0; index < target.length; index += 1) {
        if (target[index] === ' ') {
          output += ' ';
        } else {
          output += index < reveal ? target[index] : chars[Math.floor(Math.random() * chars.length)];
        }
      }

      element.textContent = output;
      if (frame >= total) {
        window.clearInterval(element._schScrambleTimer);
        element.textContent = target;
      }
    }, 38);
  }

  function init() {
    var elements = document.querySelectorAll('[data-scramble]');
    elements.forEach(function (element) {
      targetFor(element);
      element.addEventListener('mouseenter', function () {
        scramble(element);
      });
    });

    var pageTitle = document.querySelector('h1[data-scramble]');
    if (pageTitle) {
      window.setTimeout(function () {
        scramble(pageTitle);
      }, 300);
    }
  }

  window.SchuheidaScramble = scramble;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
